const $ = jQuery;
import Flickity from 'flickity';
export default {
    init( el, config ){
        const flickity = new Flickity( el, {
            wrapAround: false,
            cellAlign: 'left',
            pageDots: false
        });

        $(el).data('flickity', flickity);

        let timeout;
        if( window.MutationObserver ){
            const observer = new MutationObserver( function(){
                clearTimeout(timeout);
                timeout = setTimeout(()=>{
                    flickity.resize();
                }, 50);
            });
            observer.observe( el, {
                childList: true,
                subtree: true
            });
        }

    }
};